import { useApiQuery } from "../../hooks/useApiQuery";
import { metaApi } from "../../api/endpoints/meta.api";

const ENV_STYLES: Record<string, { bg: string; text: string; border: string; label: string }> = {
  main:  { bg: "bg-red-100",    text: "text-red-700",    border: "border-red-300",    label: "PROD" },
  dev:   { bg: "bg-yellow-100", text: "text-yellow-800", border: "border-yellow-300", label: "DEV" },
  demo:  { bg: "bg-blue-100",   text: "text-blue-700",   border: "border-blue-300",   label: "DEMO" },
  local: { bg: "bg-gray-100",   text: "text-gray-700",   border: "border-gray-300",   label: "LOCAL" },
};

const FALLBACK = { bg: "bg-gray-100", text: "text-gray-700", border: "border-gray-300", label: "" };

export function EnvBadge() {
  const { data } = useApiQuery(() => metaApi.get(), []);
  if (!data) return null;
  const style = ENV_STYLES[data.env] ?? { ...FALLBACK, label: String(data.env).toUpperCase() };
  const tooltip = `env: ${data.env}\ndb: ${data.db}${data.app_version ? `\nversion: ${data.app_version}` : ""}`;
  return (
    <span
      title={tooltip}
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-bold tracking-wider ${style.bg} ${style.text} ${style.border}`}
    >
      {style.label}
    </span>
  );
}
